module.exports = __webpack_public_path__ + "images/bannerFR-eb51a7c38fa5804e768d600ce17e667d.png";